export class PurchaseOrder {
  constructor() {
    this.date,
      this.wareHouse_id,
      this.is_active,
      this.supplier_id,
      this.document,
      (this.products = []),
      this.remarks,
      this.code;
  }
}
